









































































import {Component, Vue} from "vue-property-decorator";
import PagedTableView from "@/components/PagedTableView/index.vue";
import api from '@/api'
import {DonateDetailDto} from "@/api/appService";
import ImportExcel from "@/components/ImportExcel/index.vue";


@Component({
  name: 'DonateDetail',
  components: {
    PagedTableView,
    ImportExcel
  }
})
export default class DonateDetailManagement extends Vue {


  queryForm = {
    startDate: '',
    endDate: '',
    startMoney: undefined,
    endMoney: undefined,
    donorName: '',
    donationIntent: ''
  }

  fetchData(params: any) {
    return api.donateDetail.getAll(params)
  }

  async handleDelete(index: number, row: DonateDetailDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.donateDetail
        .delete({
          id: row.id,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    });
  }

}

